import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { PersonOutline, PhoneOutlined, EmailOutlined } from '@mui/icons-material';
import { usePMDetailsEditor } from '../../../../hooks/usePMDetailsEditor';
import { useGetActiveVendorsQuery } from '../../../../../../services/VendorService';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

/**
 * PMVendorContactDisplay - Shows resolved vendor contact info 
 * from the cached dropdown data based on the stored vendorId.
 */
export const PMVendorContactDisplay: React.FC<Props> = ({ mode }) => {
  const { pmDetails } = usePMDetailsEditor(mode);
  const { data: vendors = [] } = useGetActiveVendorsQuery();

  const vendor = vendors.find(v => v.id === pmDetails?.vendorId);

  if (!vendor) return null;

  return (
    <Box
      sx={{
        p: 1.5,
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 1,
      }}
    >
      <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 500, mb: 0.5, display: 'block' }}>
        Vendor Contact
      </Typography>
      <Stack spacing={0.5}>
        {vendor.primaryContactName && (
          <Stack direction="row" spacing={1} alignItems="center">
            <PersonOutline sx={{ fontSize: 16, color: '#64748b' }} />
            <Typography variant="body2">{vendor.primaryContactName}</Typography>
          </Stack>
        )}
        {vendor.primaryPhone && (
          <Stack direction="row" spacing={1} alignItems="center">
            <PhoneOutlined sx={{ fontSize: 16, color: '#64748b' }} />
            <Typography variant="body2">{vendor.primaryPhone}</Typography>
          </Stack>
        )}
        {vendor.primaryEmail && (
          <Stack direction="row" spacing={1} alignItems="center">
            <EmailOutlined sx={{ fontSize: 16, color: '#64748b' }} />
            <Typography variant="body2">{vendor.primaryEmail}</Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default PMVendorContactDisplay;
